import styled from "styled-components"

export const HeaderTop = styled.header`
  width: calc(100% + 2px);
  margin-left: -1px;
  margin-right: -1px;
  margin-top: -1px;
  background: black;
  display:flex;
  flex-direction: row;
  align-items: center;
  height: 70px;
  padding: 0 2em;
  @media (min-width: 999px) {
    /* padding: 50px 0px; */
  }
`

export const Logo = styled.svg`
  flex: none;
  fill: #FFFFFF;
  transition: fill 0.25s;
  width: 100px;
  padding-bottom: 10px;
  @media (min-width: 999px) {
    width: 120px;
  }
`
